const WEEK = 7 * 24 * 60 * 60 * 1000;

export function getRoundupNumber(startDate, now = new Date()) {
  const elapsed = new Date(now) - new Date(startDate);
  return Number.isFinite(elapsed) && elapsed >= 0 ? Math.floor(elapsed / WEEK) + 1 : null;
}

export function scoreRating(value, aim) {
  const actual = Number(value);
  const target = Number(aim);
  if (!Number.isFinite(actual) || !Number.isFinite(target)) return { className: '', label: 'No score' };
  if (target <= 0) return actual <= target
    ? { className: 'good', label: 'Target met' }
    : { className: 'bad', label: 'Above target' };
  const ratio = actual / target;
  return ratio < 0.33 ? { className: 'bad', label: 'Below target' }
    : ratio < 0.66 ? { className: 'medium', label: 'Making progress' }
    : { className: 'good', label: ratio >= 1 ? 'Target met' : 'Close to target' };
}

export function roundupStats(goals, issues, tasks, roundupId) {
  const belongs = (item, field) => !!roundupId && String(item[field] || '') === String(roundupId);
  return {
    tasksFinished: tasks.filter(item => item.status === 'completed' && belongs(item, 'completed_roundup_id')).length,
    issuesSolved: issues.filter(item => item.status === 'completed' && belongs(item, 'completed_roundup_id')).length,
    goalsCompleted: goals.filter(goal => goal.status === 'completed').length,
    inProgressGoals: goals.filter(goal => goal.status === 'in-progress').length,
    issuesRaised: issues.filter(item => belongs(item, 'created_roundup_id')).length,
    tasksCreated: tasks.filter(item => belongs(item, 'created_roundup_id')).length
  };
}

export const summaryLabels = [
  ['tasksFinished', 'Tasks finished'], ['issuesSolved', 'Issues solved'], ['goalsCompleted', 'Goals complete'],
  ['inProgressGoals', 'Goals in progress'], ['issuesRaised', 'Issues raised'], ['tasksCreated', 'Tasks created']
];
